export var EAlertType;
(function (EAlertType) {
    EAlertType["WRONG_WAY_DETECTION"] = "WRONG_WAY_DETECTION";
    EAlertType["LOW_CONNECT_ITS_HUB_BATTERY"] = "LOW_CONNECT_ITS_HUB_BATTERY";
    EAlertType["DEMO_HEAVY_SNOWFALL"] = "DEMO_HEAVY_SNOWFALL";
    EAlertType["DEMO_TRAFFIC_JAM"] = "DEMO_TRAFFIC_JAM";
})(EAlertType || (EAlertType = {}));
